import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../service/translate.service';
import { Router } from '@angular/router';
import { ScheduleEquipmentComponent } from '../components/schedule/schedule-equipment/schedule-equipment.component';


@Pipe({
  name: 'translate',
  pure: false
})
export class TranslationPipe implements PipeTransform {

  constructor(private translationService: TranslationService,private router: Router) {}

  transform(value: any, args?: any): any {
   /* if(this.router.url=='schedule-equipment'){
   this.scheduleEquipmentComponent.reloadEvents();
   } */
    return this.translationService.translate(value);
  }
}
